// Token de PREVIEW (outil de dev) : lu depuis l'URL (?pvtoken=...) et gardé EN MÉMOIRE.
// Le contexte JS d'une iframe est isolé de la fenêtre parente → ce token n'affecte
// JAMAIS la session admin (aucune écriture dans localStorage/sessionStorage partagés).
let _token = null;
try {
  const p = new URLSearchParams(window.location.search);
  const t = p.get('pvtoken');
  if (t) _token = t;
} catch (e) {
  _token = null;
}

export const getPreviewToken = () => _token;
export const isPreviewMode = () => !!_token;
